(function () {
  "use strict";

  if (!window.DNB) {
    return;
  }

  function parseValue(text) {
    var cleaned = text.trim();
    var number = parseFloat(cleaned.replace(/[^0-9.]/g, ""));
    var suffix = cleaned.replace(/[0-9.]/g, "");
    return { number: number, suffix: suffix };
  }

  function getStoredTarget(el) {
    if (el.dataset.countupTargetNumber) {
      return {
        number: parseFloat(el.dataset.countupTargetNumber),
        suffix: el.dataset.countupTargetSuffix || ""
      };
    }

    var parsed = parseValue(el.textContent); 
    if (isNaN(parsed.number)) {
      return null;
    }

    el.dataset.countupTargetNumber = String(parsed.number);
    el.dataset.countupTargetSuffix = parsed.suffix;
    return parsed;
  }

  function getDurationForTarget(targetNumber) {
    var minDuration = 2.6;
    var maxDuration = 4.6;
    var clamped = Math.max(0, Math.min(targetNumber, 200));
    var ratio = clamped / 200;
    return maxDuration - (maxDuration - minDuration) * ratio;
  }

  window.DNB.register(function () {
    var section = document.querySelector(".facts");
    var list = section ? section.querySelector(".facts__list") : null;
    var values = document.querySelectorAll("[data-countup-value]");
    if (!values.length) {
      return;
    }

    if (!list) {
      return;
    }

    values.forEach(function (valueEl) {
      var target = getStoredTarget(valueEl);
      if (!target) {
        return;
      }
      valueEl.textContent = "0" + target.suffix;
    });

    function animateValue(el) {
      if (el.dataset.countupAnimated === "true") {
        return;
      }
      el.dataset.countupAnimated = "true";
      var textEl = el.querySelector(".dnb-reveal__inner") || el;
      var target = getStoredTarget(el);
      if (!target || isNaN(target.number)) {
        return;
      }

      var state = { value: 0 };
      if (window.gsap) {
        window.gsap.to(state, {
          value: target.number,
          duration: getDurationForTarget(target.number),
          ease: "power4.out",
          onUpdate: function () {
            var rounded = Math.round(state.value);
            textEl.textContent = rounded + target.suffix;
          }
        });
      } else {
        textEl.textContent = target.number + target.suffix;
      }
    }

    var items = Array.prototype.slice.call(list.querySelectorAll(".facts__item"));
    var swiper = null;
    var sliderContainer = null;
    var paginationEl = null;
    var listParent = list.parentNode;
    var listNextSibling = list.nextSibling;
    var isMobileQuery =
      typeof window.matchMedia === "function" && window.matchMedia("(max-width: 640px)");

    function animateItem(item) {
      if (!item || item.dataset.countupAnimated === "true") {
        return;
      }
      item.dataset.countupAnimated = "true";
      var itemValues = item.querySelectorAll("[data-countup-value]");
      if (!itemValues.length) {
        return;
      }

      var runCountup = function () {
        itemValues.forEach(function (valueEl) {
          animateValue(valueEl);
        });
      };

      if (window.DNB && typeof window.DNB.revealText === "function" && window.gsap) {
        var revealTimeline = window.DNB.revealText(itemValues, {
          stagger: 0.08,
          duration: 1.4,
          ease: "expo.out"
        });

        if (revealTimeline) {
          revealTimeline.call(runCountup, null, 0.5);
        } else {
          runCountup();
        }
      } else {
        runCountup();
      }
    }

    function triggerAllDesktop() {
      var runCountup = function () {
        values.forEach(function (valueEl) {
          animateValue(valueEl);
        });
      };

      if (window.DNB && typeof window.DNB.revealText === "function" && window.gsap) {
        var revealTimeline = window.DNB.revealText(values, {
          stagger: 0.08,
          duration: 1.8,
          ease: "expo.out"
        });

        if (revealTimeline) {
          revealTimeline.call(runCountup, null, 0.7);
        } else {
          runCountup();
        }
      } else {
        runCountup();
      }
    }

    function observeFirstItem(item) {
      if (!item || !("IntersectionObserver" in window)) {
        animateItem(item);
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              animateItem(item);
              observer.disconnect();
            }
          });
        },
        { threshold: 0.4 }
      );

      observer.observe(item);
    }

    function setupSwiper() {
      if (swiper || !window.Swiper) {
        return;
      }

      sliderContainer = document.createElement("div");
      sliderContainer.className = "facts__slider swiper";
      listParent.insertBefore(sliderContainer, list);
      sliderContainer.appendChild(list);

      list.classList.add("swiper-wrapper", "facts__list--swiper");
      items.forEach(function (item) {
        item.classList.add("swiper-slide");
      });

      paginationEl = document.createElement("div");
      paginationEl.className = "facts__pagination swiper-pagination";
      sliderContainer.appendChild(paginationEl);

      swiper = new window.Swiper(sliderContainer, {
        slidesPerView: 1,
        spaceBetween: 24,
        speed: 550,
        watchOverflow: true,
        pagination: {
          el: paginationEl,
          clickable: true
        },
        on: {
          init: function () {
            observeFirstItem(items[0]);
          },
          slideChange: function () {
            var activeIndex = this.activeIndex || 0;
            animateItem(items[activeIndex]);
          }
        }
      });
    }

    function teardownSwiper() {
      if (swiper) {
        swiper.destroy(true, true);
        swiper = null;
      }

      if (paginationEl && paginationEl.parentNode) {
        paginationEl.parentNode.removeChild(paginationEl);
      }
      paginationEl = null;

      items.forEach(function (item) {
        item.classList.remove("swiper-slide");
      });
      list.classList.remove("swiper-wrapper", "facts__list--swiper");

      if (sliderContainer && sliderContainer.parentNode) {
        sliderContainer.parentNode.insertBefore(list, sliderContainer);
        sliderContainer.parentNode.removeChild(sliderContainer);
      }
      sliderContainer = null;
    }

    function handleModeChange(isMobile) {
      if (isMobile) {
        setupSwiper();
      } else {
        teardownSwiper();
        if ("IntersectionObserver" in window) {
          var observer = new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                  triggerAllDesktop();
                  observer.disconnect();
                }
              });
            },
            { threshold: 0.4 }
          );

          observer.observe(values[0]);
        } else {
          triggerAllDesktop();
        }
      }
    }

    if (isMobileQuery && typeof isMobileQuery.addEventListener === "function") {
      handleModeChange(isMobileQuery.matches);
      isMobileQuery.addEventListener("change", function (event) {
        handleModeChange(event.matches);
      });
    } else if (isMobileQuery && typeof isMobileQuery.addListener === "function") {
      handleModeChange(isMobileQuery.matches);
      isMobileQuery.addListener(function (event) {
        handleModeChange(event.matches);
      });
    } else {
      handleModeChange(false);
    }
  });
})();
